module.exports = __webpack_public_path__ + "static/media/expired.513455a8.png";